<template>
  <section v-on:click="sectionClicked">
    <Header :class="{scrolled: isScrolled}" ref="header"/>
    <div class="mainCnt">
      <div class="cnt">
        <div class="main">
          <div class="mainItem m1">
            <h4>Let's Team Up, <span>Not Give Up.</span></h4>
            <p>60 tahun terakhir ini polusi semakin memburuk akibat pabrik,
              kendaraan, dan pembakaran batu bara untuk membangkitkan tenaga listrik.</p>
            <p>Polusi berkumpul di udara menjadi gulungan selimut yang membuat Bumi terlalu panas.
              Suhu Bumi yang terlalu panas menyebabkan kekeringan, gagal panen, cuaca ekstrim, dan
              permukaan laut naik menggenangi daratan.</p>
            <p>Ini adalah ajakan untuk sama-sama bertindak sesuai kemampuan kita,
              agar selimut polusi tidak jadi makin tebal. Sekecil apa pun langkah yang kita ambil,
              kalau dilakukan bersama-sama akan besar dampaknya.</p>
            <button v-on:click="openTeamUp(null)">Let's Team Up For Impact</button>
          </div>
          <div class="mainItem m2">
            <div class="videoCnt" v-on:click="$emit('fireal', 'play_video', 'home')">
              <iframe
                src="https://www.youtube.com/embed/6Mbm1UG2UzY?autoplay=1"
                title="YouTube video player" frameborder="0"
                allow="accelerometer; clipboard-write; encrypted-media;
                gyroscope; picture-in-picture"
                allowfullscreen></iframe>
              <div class="playIcon">
                <div class="icon"></div>
                Tonton Video
              </div>
            </div>
            <div class="videoCaption"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="welcome">
      <div class="cnt">
        <div v-on:click="openTeamUp('sun')"
          class="welcomeItem sun"><div class="img"></div></div>
        <div v-on:click="openTeamUp('leaf')"
          class="welcomeItem leaf">
          <div class="img"></div><div class="img img2"></div>
        </div>
        <div v-on:click="openTeamUp('recycle')"
          class="welcomeItem recycle"><div class="img"></div></div>
        <div v-on:click="openTeamUp('wind')"
          class="welcomeItem wind">
          <div class="img"></div>
          <div class="img img2"></div>
          <div class="img imgSm"></div>
          <div class="img imgSm img2"></div>
          <div class="img imgMd"></div>
          <div class="img imgMd img2"></div>
        </div>
        <div v-on:click="openTeamUp('earth')"
          class="welcomeItem earth"><div class="img"></div></div>
        <div v-on:click="openTeamUp('carrot')"
          class="welcomeItem carrot"><div class="img"></div></div>
        <div v-on:click="openTeamUp('temp')"
          class="welcomeItem temp">
          <div class="img"></div>
          <div class="img img2"></div>
        </div>
        <div v-on:click="openTeamUp('handshake')"
          class="welcomeItem handshake">
          <div class="img"></div>
          <div class="img img2"></div>
        </div>
        <div v-on:click="openTeamUp('lamp')"
          class="welcomeItem lamp">
          <div class="img"></div>
          <div class="img img2"></div>
        </div>
        <div v-on:click="openTeamUp('industry')"
          class="welcomeItem industry">
          <div class="img"></div>
          <div class="img img2"></div>
        </div>
      </div>
    </div>
    <div class="teamUpNotGiveUp" v-if="1>2">
      <div class="cnt">
        <h4>Let's Team Up, <span>Not Give Up.</span></h4>
        <p>Ini adalah sebuah ajakan untuk melakukan hal-hal sederhana
        untuk bumi. Kapan saja, di mana saja, sejauh yang kita bisa.</p>
        <p>Karena sekecil apa pun langkah yang kita ambil, kalau
        dilakukan secara bersama-sama dan terus menerus akan besar dampaknya.</p>
        <button v-on:click="openTeamUp">Let's Team Up For Impact</button>
      </div>
    </div>
    <div class="videoCnt" v-if="1>2">
      <div class="cnt">
        <div class="video">
          <iframe
            src="https://www.youtube.com/embed/6Mbm1UG2UzY?autoplay=1"
            title="YouTube video player" frameborder="0"
            allow="accelerometer; clipboard-write; encrypted-media;
            gyroscope; picture-in-picture"
            allowfullscreen></iframe>
          <!-- <div class="playIcon"></div> -->
        </div>
      </div>
    </div>
    <div class="logoKoalisi loading" v-if="loadingLogoKoalisi"></div>
    <div class="logoKoalisi" v-else>
      <div class="cnt">
        <a :href="item.webUrl" target="_blank"
          v-on:click="$emit('fireal', 'logo_koalisi_clicked', 'home',
          {id: item.id, name: item.name})"
          v-for="(item, i) in logoKoalisi" :key="i">
          <img :src="item.uri">
        </a>
      </div>
    </div>
    <div class="section">
      <div class="cnt">
        <h4 class="sectionTitle">Latest Blog Post</h4>
        <div class="blogCnt loading" v-if="loadingBlog">
          <div class="blogItem" v-for="i in 3" :key="`blog${i}`">
            <div class="blogImg noImg"></div>
            <h4>Kamu Emosi, Saya Emosi, Kita Semua Terjebak
              di Tengah Teriknya Efek Perubahan Iklim</h4>
            <p>Karsten Wurth/UNSPLASH Suara gemuruh itu datang dengan
              begitu mengerikan sama seperti apa yang dibawanya.
              Tidak ada peringatan yang repot-repot d…...</p>
          </div>
        </div>
        <div class="blogCnt" v-else>
          <a :href="item.url" target="_blank"
            v-on:click="$emit('fireal', 'blog_clicked', 'home', {id: item.id, name: item.title})"
            class="blogItem" v-for="(item, i) in blogPosts" :key="`blog${i}`">
              <div class="blogImg hasImg" v-if="item.imageUrl"
                :style="{'background-image': `url(${item.imageUrl})`}"></div>
              <div class="blogImg noImg" v-else></div>
            <h4>{{item.title}}</h4>
            <p v-if="item.summary">{{item.summary.substr(0, 180)}}...</p>
          </a>
        </div>
        <div class="viewAllCnt">
          <router-link to="/blog"
            v-on:click="$emit('fireal', 'all_blog_clicked', 'home')"
            class="viewAllBlog btn outline" v-if="!loadingBlog">
            View all blog posts
          </router-link>
        </div>
      </div>
    </div>
    <div class="section sectionSocmed">
      <div class="cnt">
        <h4 class="sectionTitle">Social Media Post</h4>
        <div class="blogCnt loading" v-if="loadingSocmed">
          <div class="blogItem socmed" v-for="i in 3" :key="`socmed${i}`">
            <div class="blogImg noImg"></div>
            <h4>Kamu Emosi, Saya Emosi, Kita Semua Terjebak
              di Tengah Teriknya Efek Perubahan Iklim</h4>
          </div>
        </div>
        <div class="blogCnt" v-else>
          <a :href="item.url" target="_blank"
            v-on:click="$emit('fireal', 'socmed_clicked', 'home', {id: item.id, name: item.title})"
            class="blogItem socmed" v-for="(item, i) in socmeds" :key="`socmed${i}`">
            <div class="blogImg hasImg" v-if="item.imageUrl"
              :style="{'background-image': `url(${item.imageUrl})`}"></div>
            <div class="blogImg noImg" v-else></div>
            <h4 v-if="item.title">{{item.title.substr(0, 75)}}<span
              v-if="item.title.length > 75">...</span></h4>
          </a>
        </div>
        <div class="viewAllCnt viewAllSocmed">
          <router-link to="/untukmubumiku"
            v-on:click="$emit('fireal', 'all_socmed_clicked', 'home')"
            class="viewAllBlog btn outline" v-if="!loadingSocmed">
            View all social media posts
          </router-link>
        </div>
      </div>
    </div>
    <Joined ref="joined"/>
  </section>
</template>

<script>
import Header from '@/components/Header.vue';
import Joined from '@/components/Joined.vue';

export default {
  name: 'home',
  components: { Header, Joined },
  data() {
    return {
      isScrolled: false,
      loadingLogoKoalisi: true,
      logoKoalisi: [],
      loadingBlog: true,
      loadingSocmed: true,
      socmeds: [],
      blogPosts: [],
      scAlTimer: null,
    };
  },
  created() {
    document.addEventListener('scroll', this.scrolled);
  },
  destroyed() {
    document.removeEventListener('scroll', this.scrolled);
  },
  computed: {},
  methods: {
    doNothing() {},
    sectionClicked() {
      if (this.$refs.header) this.$refs.header.sectionClicked();
    },
    scrolled() {
      this.isScrolled = window.scrollY > 30;
      if (this.scAlTimer) clearTimeout(this.scAlTimer);
      this.scAlTimer = setTimeout(() => {
        this.$emit('fireal', 'scroll', 'home');
      }, 500);
    },
    playVideo() {
      this.$refs.joined.open();
    },
    openTeamUp(icon) {
      if (!icon) {
        this.$emit('fireal', 'teamup_everyday_btn_clicked', 'home');
      } else {
        this.$emit('fireal', 'teamup_everyday_icon_clicked', 'home', { icon });
      }
      this.$router.push('/team-up-everyday');
    },
    fireAlEvent(convId) {
      this.$emit('fireal', 'page_visit', 'home', null, convId, (r) => {
        if (r.data.status !== 200) return;
        alTimer = setTimeout(() => {
          this.fireAlEvent(r.data.id);
        }, 5000);
      });
    },
  },
  beforeDestroy() {
    if (alTimer) clearTimeout(alTimer);
  },
  mounted() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    document.title = 'Team Up For Impact';
    this.$http.get(this.$config.uri('misc/koalisi/logo')).then((r) => {
      this.logoKoalisi = (r.data.status === 200) ? r.data.data : [];
      this.loadingLogoKoalisi = false;
    });
    this.$http.get(this.$config.uri('misc/blog/post?limit=3')).then((r) => {
      this.blogPosts = (r.data.status === 200) ? r.data.data : [];
      this.loadingBlog = false;
    });
    this.$http.get(this.$config.uri('misc/feed/instagram?limit=9')).then((r) => {
      this.socmeds = r.data.status === 200 ? r.data.data : [];
      this.loadingSocmed = false;
    });

    this.fireAlEvent();
  },
};
</script>

<style scoped lang="scss">
@keyframes leafanimation {
  0% {transform:rotateY(0);}
  25% {transform:rotateY(35deg);}
  50% {transform:rotateY(0);}
  75% {transform:rotateY(35deg);}
  100% {transform:rotateY(0);}
}
@keyframes spriteanimation {
  from {background-position: 0 50%;}
  to {background-position: 100% 50%;}
  // to {background-position: 99.62% 50%;}
}
@keyframes handshakeanimation {
  0% {transform:translateY(0);}
  25% {transform:translateY(-10px);}
  50% {transform:translateY(0);}
  75% {transform:translateY(-10px);}
  100% {transform:translateY(0);}
}
@keyframes handshakeanimation2 {
  0% {opacity:0;}
  25% {opacity:0;}
  50% {transform:scale(1);}
  75% {transform:scale(.9);}
  100% {transform:scale(1);}
}
@keyframes lampanimation {
  0% {filter:grayscale(1);}
  100% {filter:grayscale(0);}
}
@keyframes lampanimation2 {
  0% {opacity:0;}
  25% {opacity:0;}
  50% {transform:scale(1);}
  75% {transform:scale(1.1);}
  100% {transform:scale(1);}
}
@keyframes industryanimation {
  0% {transform:scale(.8);}
  75% {transform:scale(1.1);}
  100% {transform:scale(1);}
}
@keyframes carrotanimation {
  0 {
    transform: translateX(0);
  }
  12.5% {
    transform: translateX(-6px) rotateY(-9deg) skewY(1deg);
  }
  37.5% {
    transform: translateX(5px) rotateY(4.5deg) skewY(-1deg);
  }
  62.5% {
    transform: translateX(-3px) rotateY(-2.25deg) skewY(0);
  }
  87.5% {
    transform: translateX(2px) rotateY(3deg);
  }
  100% {
    transform: translateX(0);
  }
}

.mainCnt{
  background-image: url(../assets/home-blur.jpg);
  background-size: cover;
  background-position: center;
  padding-top: 40px;
  &:before{
    content: "";
    position: absolute;
    left: 0; top: 0; right: 0; bottom: 0;
    background-color: #fff;
    opacity: .26;
    @media (max-width: 1480px) {
      opacity: .36;
    }
    @media (max-width: 1029px) {
      opacity: .46;
    }
    @media (max-width: 869px) {
      opacity: .56;
    }
  }
  .cnt{
    position: relative;
    z-index: 3;
  }
}
.main{
  display: flex;
  min-height: calc(98vh - 60px);
  align-items: center;
  @media (max-width: 1029px) {
    display: block;
  }
  @media (max-width: 860px) {
    min-height: 0;
  }
  .mainItem{
    box-sizing: border-box;
    &.m1{
      width: calc(100% - 760px);
      padding: 160px 0;
      @media (max-width: 1480px) {
        width: calc(100% - 680px);
      }
      @media (max-width: 1240px) {
        width: calc(100% - 620px);
      }
      @media (max-width: 1029px) {
        width: auto;
        max-width: 640px;
        margin: 0 auto;
        padding: 140px 0 60px;
        text-align: center;
        max-width: 600px;
      }
      @media (max-width: 860px) {
        padding: 100px 0 40px;
      }
      h4{
        text-transform: uppercase;
        font-size: 54px;
        color: #5351a4;
        margin: 0 0 10px;
        line-height: 1.1;
        font-family: 'GolosUIWebBold', sans-serif;
        @media (max-width: 1480px) {
          font-size: 46px;
        }
        @media (max-width: 1240px) {
          font-size: 46px;
        }
        @media (max-width: 860px) {
          font-size: 34px;
        }
        span{
          color: #f14724;
          display: block;
        }
      }
      p{
        margin: 0 auto 10px;
        font-size: 18px;
        max-width: 960px;
        line-height: 1.3;
        @media (max-width: 1480px) {
          font-size: 15px;
        }
        @media (max-width: 860px) {
          font-size: 15px;
        }
      }
      button{
        text-transform: uppercase;
        margin-top: 16px;
        padding: 14px 20px 12px;
        font-size: 17px;
        border-radius: 3px;
        @media (max-width: 1480px) {
          padding: 12px 20px 10px;
          font-size: 16px;
        }
        @media (max-width: 860px) {
          padding: 10px 20px 8px;
          font-size: 16px;
        }
      }
    }
    &.m2{
      padding-left: 100px;
      box-sizing: border-box;
      width: 760px;
      @media (max-width: 1480px) {
        width: 680px;
      }
      @media (max-width: 1240px) {
        width: 629px;
      }
      @media (max-width: 1029px) {
        width: auto;
        padding: 0 60px 140px;
      }
      @media (max-width: 860px) {
        padding: 0 10px 60px;
      }
      .videoCnt{
        height: 251px;
        background-color: #222;
        // background-image: url(../assets/video-bg.jpg);
        background-size: cover;
        background-position: center;
        position: relative;
        // border-radius: 10px;
        cursor: pointer;
        // display: flex;
        // justify-content: center;
        // align-items: center;
        border-radius: 5px;
        overflow: hidden;
        @media (max-width: 1480px) {
          height: 206px;
        }
        @media (max-width: 1240px) {
          height: 176px;
        }
        @media (max-width: 1029px) {
          height: calc(40vw - 60px);
        }
        @media (max-width: 860px) {
          height: calc(40vw - 40px);
        }
        iframe{
          position: absolute;
          left: 0; top: 0;
          width: 100%; height: 100%;
        }
        .playIcon{
          position: absolute;
          left: 50%; top: 50%;
          transform: translate(-50%, -50%);
          color: #f2e522;
          text-align: center;
          font-size: 14px;
          opacity: .56;
          transition: all .3s ease;
          display: none;
          .icon{
            width: 50px; height: 50px;
            background-size: 24px auto;
            background-position: 15px 50%;
            background-repeat: no-repeat;
            border-radius: 50%;
            border: #f2e522 2px solid;
            margin: 0 auto 10px;
          }
        }
        &:hover{
          .playIcon{
            opacity: 1;
          }
        }
      }
      .videoCaption{
        display: none;
        color: #767676;
        font-size: 14px;
        padding: 5px 0 0 7px;
      }
    }
  }
}

.welcome{
  padding: 0 0 60px;
  @media (max-width: 960px) {
    // padding-top: 60px;
  }
  @media (max-width: 740px) {
    // padding-bottom: 40px;
  }
  .cnt{
    display: flex;
    flex-wrap: wrap;
    @media (max-width: 960px) {
      margin: 0;
    }
  }
  .welcomeItem{
    width: 20%;
    height: 280px;
    position: relative;
    overflow: hidden;
    cursor: pointer;
    @media (max-width: 1480px) {
      height: 240px;
    }
    @media (max-width: 1280px) {
      height: 19.05vw;
    }
    @media (max-width: 960px) {
      height: 20vw;
    }
    @media (max-width: 740px) {
      // width: 50%; height: 50vw;
    }
    .img{
      background-size: 100% auto;
      background-position: center;
      background-repeat: no-repeat;
      background-size: contain;
      position: absolute;
      left: 0; top: 0; right: 0; bottom: 0;
      transition: all 1.2s ease;
    }
    &.sun{
      background-color: #5351a4;
      .img{
        background-image: url(../assets/home-sun.png);
      }
      &:hover{
        .img{
          transform: rotate(180deg);
        }
      }
    }
    &.leaf{
      background-color: #fdbb30;
      .img{
        top: 20px;
        background-image: url(../assets/home-leaf.png);
        right: 40%;
        &.img2{
          left: 40%; right: 0;
        }
      }
      &:hover{
        .img{
          animation: leafanimation 1s linear;
        }
      }
    }
    &.recycle{
      background-color: #1c7e67;
      .img{
        top: 60px; left: 60px; right: 60px; bottom: 60px;
        background-image: url(../assets/home-recycle.png);
        background-size: auto 100%;
        background-position: 0 50%;
        transition: none;
        @media (max-width: 1480px) {
          top: 50px; left: 50px; right: 50px; bottom: 50px;
        }
        @media (max-width: 1280px) {
          top: 4.5vw; right: 4.5vw; bottom: 4.5vw; left: 4.5vw;
        }
        @media (max-width: 740px) {
          // top: 8vw; right: 8vw; bottom: 8vw; left: 8vw;
        }
      }
      &:hover{
        .img{
          // background-position: 100% 50%;
          animation: spriteanimation .5s steps(17) 1 forwards;
        }
      }
    }
    &.wind{
      background-color: #f14722;
      .img{
        top: 40px; bottom: -20px;
        background-image: url(../assets/home-wind.png);
        transition: transform 1.2s ease;
        @media (max-width: 1280px) {
          top: 2vw; bottom: -1vw;
        }
        @media (max-width: 740px) {
          // top: 4vw; bottom: -2vw;
        }
        &.img2{
          left: 50%; right: auto; bottom: auto; top: 24px;
          width: 160px; height: 160px;
          margin-left: -80px;
          background-image: url(../assets/home-wind2.png);
          @media (max-width: 1280px) {
            width: 10vw; height: 10vw;
            margin-left: -5vw;
            top: 1.5vw;
          }
          @media (max-width: 740px) {
            // width: 20vw; height: 20vw;
            // margin-left: -10vw;
            // top: 6vw;
          }
        }
        &.imgSm{
          right: 80px; top: 60px; left: 20px; bottom: -60px;
          @media (max-width: 1280px) {
            right: 8vw; top: 6vw; left: 2.7vw; bottom: -6vw;
          }
          @media (max-width: 740px) {
            // right: 18vw; top: 10vw; left: 0vw; bottom: -10vw;
          }
          &.img2{
            transition: transform 2.8s ease;
            right: auto; left: 50%;
            width: 60px; height: 60px;
            margin-left: -60px; top: 128px;
            @media (max-width: 1280px) {
              top: 10.8vw;
              width: 5vw; height: 5vw;
              margin-left: -5.2vw;
            }
            @media (max-width: 740px) {
              // top: 21vw;
              // width: 12vw; height: 12vw;
              // margin-left: -15vw;
            }
          }
        }
        &.imgMd{
          right: -20px; top: 20px; left: 80px; bottom: -50px;
          @media (max-width: 1280px) {
            right: -2vw; top: 2vw; left: 7.1vw; bottom: -5vw;
          }
          @media (max-width: 740px) {
            // right: -16vw; top: 8vw; left: 8vw; bottom: -7vw;
          }
          &.img2{
            transition: transform 1.6s ease;
            right: auto; top: 40px; left: 50%;
            width: 100px; height: 100px;
            margin-left: 0; top: 72px;
            @media (max-width: 1280px) {
              width: 7vw; height: 7vw;
              top: 6vw; left: 10.7vw
            }
            @media (max-width: 740px) {
              // width: 16vw; height: 16vw;
              // left: 29vw; top: 13vw;
            }
          }
        }
      }
      &:hover{
        .img.img2{
          transform: rotate(360deg);
        }
        .img.imgSm.img2{
          transform: rotate(720deg);
        }
      }
    }
    &.carrot{
      background-color: #1c7e67;
      .img{
        background-image: url(../assets/home-farm2.png);
        background-size: auto 100%;
        background-position: 0 50%;
        transition: all .65s ease;
      }
      &:hover{
        .img{
          background-position: 100% 50%;
          // animation: carrotanimation .7s ease;
        }
      }
    }
    &.temp{
      background-color: #a8d7f8;
      .img{
        top: 10px; right: 10px; bottom: 10px; left: 10px;
        background-image: url(../assets/home-temp.png);
        background-size: 100% auto;
        &.img2{
          background-image: url(../assets/home-temp2.png);
          background-size: 100% auto;
          background-position: 50% 100%;
          top: 150px;
          @media (max-width: 1280px) {
            top: 12vw;
          }
          @media (max-width: 740px) {
            // top: 28vw;
          }
        }
      }
      &:hover{
        .img.img2{
          top: 80px;
          @media (max-width: 1280px) {
            top: 6vw;
          }
          @media (max-width: 740px) {
            // top: 12vw;
          }
        }
      }
    }
    &.handshake{
      background-color: #f14724;
      .img{
        background-image: url(../assets/home-handshake.png);
        &.img2{
          background-image: url(../assets/home-handshake2.png);
        }
      }
      &:hover{
        .img{
          animation: handshakeanimation 1s ease;
          &.img2{
            animation: handshakeanimation2 1.4s ease;
          }
        }
      }
    }
    &.industry{
      background-color: #fdbb30;
      .img{
        top: 20px; bottom: -20px;
        background-image: url(../assets/home-industry.png);
        &.img2{
          background-image: url(../assets/home-industry2.png);
        }
      }
      &:hover{
        .img.img2{
          animation: industryanimation 1s ease;
        }
      }
    }
    &.earth{
      background-color: #5351a4;
      .img{
        top: 50px; right: 50px; bottom: 50px; left: 50px;
        border-radius: 50%;
        background-color: #a9d7f8;
        background-image: url(../assets/world-map.png);
        background-size: auto 100%;
        background-position: 100% 50%;
        transition: all .8s ease;
        @media (max-width: 1280px) {
          top: 4.5vw; right: 4.5vw; bottom: 4.5vw; left: 4.5vw;
        }
        @media (max-width: 740px) {
          // top: 9vw; right: 9vw; bottom: 9vw; left: 9vw;
        }
      }
      &:hover{
        .img{
          box-shadow: 0 10px 16px rgba(0,0,0,.2);
          background-position: 10% 50%;
        }
      }
    }
    &.lamp{
      background-color: #5351a4;
      .img{
        background-image: url(../assets/home-idea.png);
        &.img2{
          background-image: url(../assets/home-idea2.png);
        }
      }
      &:hover{
        .img{
          animation: lampanimation 1s ease;
          &.img2{
            animation: lampanimation2 1.2s ease;
          }
        }
      }
    }
  }
}

.teamUpNotGiveUp{
  text-align: center;
  padding: 60px 0;
  @media (max-width: 680px) {
    padding: 20px 0 30px;
  }
  h4{
    text-transform: uppercase;
    font-size: 46px;
    color: #5351a4;
    margin: 0 0 20px;
    font-family: 'GolosUIWebBold', sans-serif;
    @media (max-width: 1460px) {
      font-size: 38px;
      margin-bottom: 14px;
    }
    @media (max-width: 1260px) {
      font-size: 34px;
    }
    @media (max-width: 680px) {
      font-size: 26px;
    }
    span{
      color: #f14724;
      @media (max-width: 680px) {
        display: block;
      }
    }
  }
  p{
    margin: 0 auto 10px;
    font-size: 24px;
    max-width: 960px;
    @media (max-width: 1460px) {
      font-size: 20px;
      max-width: 860px;
    }
    @media (max-width: 680px) {
      font-size: 17px;
      line-height: 1.3;
    }
  }
  button{
    text-transform: uppercase;
    margin-top: 20px;
    padding: 12px 24px 10px;
    @media (max-width: 1460px) {
      padding: 10px 25px 8px;
    }
  }
}


.videoCnt{
  padding: 60px 0;
  @media (max-width: 680px) {
    padding-bottom: 20px;
  }
  .video{
    height: 680px;
    background-color: #f5f5f5;
    background-position: center;
    background-size: cover;
    background-image: url(../assets/video-cover.jpg);
    // max-width: 1080px;
    margin: 0 auto;
    position: relative;
    cursor: pointer;
    @media (max-width: 1280px) {
      height: 52vw;
    }
    @media (max-width: 680px) {
      height: 54vw;
    }
    iframe{
      width: 100%; height: 100%;
    }
    .playIcon{
      position: absolute;
      left: 50%; top: 50%;
      width: 94px; height: 94px;
      background-color: #5351a4;
      border-radius: 50%;
      margin: -47px 0 0 -47px;
      background-image: url(../assets/play-icon-white.png);
      background-size: 36px auto;
      background-position: 54% 50%;
      background-repeat: no-repeat;
      transition: all .3s ease;
      @media (max-width: 860px) {
        width: 60px; height: 60px;
        background-size: 24px auto;
        margin: -30px 0 0 -30px;
      }
      &:hover{
        box-shadow: 0 0 6px rgba(0, 0, 0, .2);
      }
    }
    &:hover{
      .playIcon{
        background-color: #615fb1;
      }
    }
  }
}

.logoKoalisi{
  text-align: center;
  padding: 60px 0 20px;
  @media (max-width: 860px) {
    padding: 0;
  }
  &.loading{
    background-image: url(../assets/loading.svg);
    background-size: 46px auto;
    background-position: center;
    background-repeat: no-repeat;
    height: 80px;
    padding: 40px 0;
    @media (max-width: 860px) {
      padding: 0;
    }
  }
  img{
    height: 80px;
    margin: 0 26px 30px;
    @media (max-width: 1480px) {
      height: 72px;
    }
    @media (max-width: 860px) {
      height: 46px;
      margin: 0 10px 10px;
    }
  }
}

.section{
  .cnt{
    @media (max-width: 1280px) {
      margin: 0 50px;
    }
    @media (max-width: 1024px) {
      margin: 0 30px;
    }
    @media (max-width: 860px) {
      margin: 0 26px;
    }
  }
  .sectionTitle{
    margin: 60px 0 30px;
    text-align: center;
    color: #5351a4;
    text-transform: uppercase;
    font-family: 'GolosUIWebBold', sans-serif;
    font-size: 34px;
    @media (max-width: 860px) {
      font-size: 20px;
      margin: 60px 0 16px;
    }
  }
  .viewAllCnt{
    text-align: center;
    margin: -30px 0 60px;
    &.viewAllSocmed{
      @media (max-width: 860px) {
        margin-top: -10px;
      }
    }
  }
  .blogCnt{
    display: flex;
    justify-content: space-between;
    padding: 0 0 20px;
    flex-wrap: wrap;
    @media (max-width: 860px) {
      display: block;
    }
    .blogItem{
      width: calc(33.333333% - 30px);
      margin-bottom: 40px;
      color: #444;
      display: block;
      @media (max-width: 1024px) {
        width: calc(33.333333% - 20px);
      }
      @media (max-width: 860px) {
        width: auto;
      }
      .blogImg{
        height: 300px;
        background-color: #eee;
        background-position: center;
        background-size: cover;
        background-repeat: no-repeat;
        margin: 0 0 16px;
        cursor: pointer;
        @media (max-width: 1480px) {
          height: 260px;
        }
        @media (max-width: 1024px) {
          height: 220px;
        }
        @media (max-width: 960px) {
          height: 180px;
        }
        @media (max-width: 860px) {
          height: 200px;
          margin: 0 0 10px;
        }
        &.noImg{
          background-image: url(../assets/image-black.png);
          background-size: 64px auto;
          background-color: #ccc;
          opacity: .36;
        }
      }
      h4{
        margin: 0 0 10px;
        font-size: 24px;
        line-height: 1.3;
        cursor: pointer;
        font-family: 'GolosUIWebBold', sans-serif;
        &:hover{
          color: #5351a4;
        }
        @media (max-width: 860px) {
          font-size: 18px;
          margin: 0 0 4px;
        }
      }
      p{
        margin: 0;
        color: #767676;
        cursor: pointer;
        &:hover{
          color: #444;
        }
        @media (max-width: 860px) {
          font-size: 14px;
        }
      }
      &.socmed{
        box-shadow: 0 0 4px rgba(0, 0, 0, .2);
        border-radius: 5px;
        overflow: hidden;
        @media (max-width: 860px) {
          margin-bottom: 16px;
        }
        .blogImg{
          margin: 0;
          height: 380px;
          @media (max-width: 1480px) {
            height: 340px;
          }
          @media (max-width: 1240px) {
            height: 300px;
          }
          @media (max-width: 1024px) {
            height: 280px;
          }
          @media (max-width: 960px) {
            height: 220px;
          }
        }
        h4{
          margin: 0;
          padding: 12px 18px;
          font-size: 16px;
          line-height: 1.2;
          @media (max-width: 960px) {
            font-size: 14px;
          }
        }
      }
    }
    &.loading{
      .blogItem{
        .blogImg{
          background-image: none;
          cursor: default;
        }
        h4{
          background-color: #eee;
          color: #eee;;
          cursor: default;
        }
        p{
          background-color: #eee;
          color: #eee;;
          cursor: default;
        }
        &.socmed{
          box-shadow: none;
        }
      }
    }
  }
  &.sectionSocmed{
    .sectionTitle{
      @media (max-width: 860px) {
        margin-top: 20px;
      }
    }
  }
}

</style>
